import { useState } from "react";
import { faqs } from "../../../mocks/communityData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70 py-14">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          {/* 左标题 */}
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-accent-600">
              <i className="ri-question-line" /> FAQ
            </span>
            <h2 className="mt-2 font-display text-3xl text-foreground-900 md:text-4xl">常见问题</h2>
            <p className="mt-4 leading-relaxed text-foreground-600">
              关于加入方式、发言规则与内容更新，这里都有答案。还有什么疑惑？
              <a href="#join" className="font-semibold text-primary-500 hover:text-primary-600">
                进来聊一聊
              </a>
              ，总有人为你解答。
            </p>
            <div className="mt-6 hidden rounded-2xl border border-accent-200 bg-accent-50 p-5 lg:block">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-lg text-white">
                  <i className="ri-service-line" />
                </span>
                <div>
                  <p className="text-sm font-bold text-accent-700">服务时间</p>
                  <p className="text-xs text-accent-600/80">社区全年无休 · 随时可聊</p>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ 列表 */}
          <div className="lg:col-span-3">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const isOpen = openIdx === i;
                return (
                  <div
                    key={i}
                    className={`overflow-hidden rounded-2xl border bg-background-50 transition ${
                      isOpen ? "border-accent-200" : "border-background-200"
                    }`}
                  >
                    <button
                      onClick={() => setOpenIdx(isOpen ? null : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3 text-base font-bold text-foreground-900">
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                            isOpen ? "bg-accent-500 text-white" : "bg-background-200 text-foreground-500"
                          }`}
                        >
                          {i + 1}
                        </span>
                        {f.q}
                      </span>
                      <i
                        className={`text-lg text-foreground-400 transition-transform duration-300 ${
                          isOpen ? "rotate-180 text-accent-500" : ""
                        }`}
                      />
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-[3.5rem] text-sm leading-relaxed text-foreground-600">{f.a}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}